/* eslint-disable no-param-reassign */

export function makeCasting ({ api }) {
    return {
        namespaced: true,
        state: {
            application: null,
        },
        getters: {
            applicationConfirmed (state) {
                return state.application && state.application.status === 'CONFIRMED';
            },
        },
        mutations: {
            SET_APPLICATION (state, application) {
                state.application = application;
            },
        },
        actions: {
            /**
             * Get the current user application and store it in state if it exists.
             */
            async updateApplication ({ rootState, rootGetters, commit }, options) {
                const { casting = null, force = false } = options || {};

                if (rootGetters['solution/hasCasting'] || force) {
                    const application = await api.getApplication(casting || rootState.solution.config.CASTING, rootState.user.user);
                    commit('SET_APPLICATION', application);
                } else {
                    console.log('[Casting] No casting key is set');
                }
            },
        },
    };
}
